var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"plot-maker-page"},[_c('iframe',{staticClass:"plot-maker-frame",attrs:{"src":_vm.frameSrc,"allow":"fullscreen 'self'"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }